import { defineRoute } from '../defineRoute';

export type SafetyLandlordRouteParams = {
  // ...
};

export type SafetyLandlordRouteParamsString = {
  // ...
};

export const SafetyLandlord = defineRoute<
  SafetyLandlordRouteParams,
  SafetyLandlordRouteParamsString
>({
  pathname: '/safety-landlord',
  nlPathname: '/veiligheid-verhuurder',
  isLandlordRoute: true,
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
